import { ref, watchEffect } from 'vue'
import { useHelpers, useTranslate } from '@/shared/lib'
import { cloneDeep } from 'lodash'
import { useLoadCabinetReportConsDays } from './api'

const useModel = () => {
  const data = ref<any[]>([])
  const total = ref(0)

  const { toTimeFormat, numToKilo } = useHelpers()
  const { trs } = useTranslate()

  const headers = ref<any>([
    { title: '№', key: 'index', sortable: false },
    { title: trs('itf.name'), key: 'name', sortable: false },
    { title: trs('itf.mater_number'), key: 'serial_number', sortable: false },
    {
      title: trs('itf.ktt'),
      key: 'ktt',
      sortable: false,
    },
    {
      title: trs('itf.date'),
      key: 'date',
      value: (item: any) => toTimeFormat(item.date),
      sortable: false,
    },
    {
      title: trs('itf.a_label'),
      align: 'center',
      children: [
        {
          title: trs('itf.sum_short'),
          key: 'a',
          value: (item: any) => numToKilo(item.a),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 1 }),
          key: 'a_1',
          value: (item: any) => numToKilo(item.a_1),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 2 }),
          key: 'a_2',
          value: (item: any) => numToKilo(item.a_2),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 3 }),
          key: 'a_3',
          value: (item: any) => numToKilo(item.a_3),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 4 }),
          key: 'a_4',
          value: (item: any) => numToKilo(item.a_4),
          sortable: false,
        },
      ],
    },
    {
      title: trs('itf.r_label'),
      align: 'center',
      children: [
        {
          title: trs('itf.sum_short'),
          key: 'r',
          value: (item: any) => numToKilo(item.r),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 1 }),
          key: 'r_1',
          value: (item: any) => numToKilo(item.r_1),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 2 }),
          key: 'r_2',
          value: (item: any) => numToKilo(item.r_2),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 3 }),
          key: 'r_3',
          value: (item: any) => numToKilo(item.r_3),
          sortable: false,
        },
        {
          title: trs('itf.tariff_count', { count: 4 }),
          key: 'r_4',
          value: (item: any) => numToKilo(item.r_4),
          sortable: false,
        },
      ],
    },
  ])

  /**
   * Функция загрузки таблицы
   */
  const loadTable = (filter: any) => {
    const result = useLoadCabinetReportConsDays(filter)

    watchEffect(() => {
      if (result.data.value) {
        /** Выставляем значения по умолчанию для null */
        data.value = cloneDeep(result.data.value.data || []).map((item: any) => {
          for (let prop in item) {
            item[prop] = item[prop] === null ? '-' : item[prop]
          }

          return item
        })

        total.value = result.data.value.payload.total
      }
    })

    return result
  }

  return {
    data,
    headers,
    total,

    loadTable,
  }
}

export default useModel
